import { Link, createFileRoute } from '@tanstack/react-router'
import { ArrowLeft, FileWarning } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { DocumentCollectionPage as DocumentCollectionPageView } from '@/pages/document-collection/document-collection-page'
import { Button } from '@/shared/ui/button'

export const Route = createFileRoute('/document-collection_/$id/')({
  component: DocumentCollectionPage,
  errorComponent: DocumentCollectionRouteError,
})

function DocumentCollectionPage() {
  const { id } = Route.useParams()

  return <DocumentCollectionPageView id={id} />
}

function DocumentCollectionRouteError({
  error,
  reset,
}: {
  error: Error
  reset: () => void
}) {
  const { t } = useTranslation()

  return (
    <main className="flex min-h-[calc(100vh-5rem)] items-center justify-center px-6 py-16">
      <section className="flex max-w-xl flex-col items-center gap-6 rounded-xl border bg-card px-8 py-10 text-center shadow-sm">
        <div className="flex size-14 items-center justify-center rounded-full bg-destructive/10 text-destructive">
          <FileWarning className="size-7" />
        </div>
        <div className="space-y-3">
          <h1 className="text-2xl font-semibold tracking-tight">
            Document collection unavailable
          </h1>
          <p className="text-sm leading-6 text-muted-foreground">
            {error.message || 'Something went wrong while opening this page.'}
          </p>
        </div>
        <div className="flex flex-col items-center gap-3 sm:flex-row">
          <Button variant="outline" onClick={reset}>
            {t('shell:tryAgain')}
          </Button>
          <Button asChild>
            <Link to="/document-collections">
              <ArrowLeft className="size-4" />
              {t('shell:backToCollections')}
            </Link>
          </Button>
        </div>
      </section>
    </main>
  )
}
